import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-breadcrumb-backoffice',
  templateUrl: './breadcrumb-backoffice.component.html',
  styleUrl: './breadcrumb-backoffice.component.css'
})
export class BreadcrumbBackofficeComponent {

  @Input('items') items: MenuItem[] | undefined
  
}
